
/****************************************** 
        수정 모드 서브 컴포넌트
******************************************/
export const ModifyMode = ({ selRecord }) => {

  // 현재 게시글 데이터
  const currentBoardData = selRecord;

  return (
    <>
      <table className="data-table-view readone">
        <caption>Modify : click the content</caption>
        <tbody>
          <tr>
            <td>Name</td>
            <td>
              <input
                type="text"
                className="name"
                size="20"
                readOnly
                value={currentBoardData.unm}
              />
            </td>
          </tr>
          <tr>
            <td>Title</td>
            <td>
              <input
                type="text"
                className="subject"
                size="60"
                defaultValue={currentBoardData.tit}
              />
            </td>
          </tr>
          <tr>
            <td>Content</td>
            <td>
              <textarea
                className="content"
                cols="60"
                rows="10"
                defaultValue={currentBoardData.cont}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td>Attachment</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </>
  );
}; ///////////// ModifyMode //////////////////


